

module.exports = __webpack_require__.stylable.create(
    "Subheader3146721514",
    {"classes":{"root":"Subheader3146721514__root","container":"Subheader3146721514__container","standard":"Subheader3146721514__standard","neutral":"Subheader3146721514__neutral","suffix":"Subheader3146721514__suffix"},"vars":{},"stVars":{},"keyframes":{}},
    ".Subheader3146721514__container{display:flex;align-items:center;min-height:48px;justify-content:space-between;padding:11px 30px;box-sizing:border-box}.Subheader3146721514__standard{background-color:#eaf7ff;border-top:1px #c1e4fe solid;border-bottom:1px #c1e4fe solid}.Subheader3146721514__neutral{background-color:rgba(22,45,61,.03);border-top:1px #dfe5eb solid;border-bottom:1px #dfe5eb solid}.Subheader3146721514__suffix{height:0;flex-shrink:0;margin-left:12px;display:flex;align-items:center}",
    2,
    "Subheader3146721514",
    __webpack_require__.stylable.$
);
